export default "__VITE_ASSET__EacgbH5Q__"